module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rooms"
  }, [_vm._m(0), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.rooms), function(room) {
    return _c('router-link', {
      key: room.id,
      staticClass: "list-group-item navigatable",
      attrs: {
        "to": {
          name: 'rooms.view',
          params: {
            id: room.id
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(room.title) + "\n            "), _c('span', {
      staticClass: "pe-7s-angle-right-circle pull-right action"
    })])
  }), 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Rooms\n\n            "), _c('small', [_vm._v("\n                 \n                "), _c('button', {
    staticClass: "btn btn-default btn-fill btn-sm"
  }, [_c('span', {
    staticClass: "fa fa-plus fa-fw"
  }), _vm._v("\n                    Add new\n                ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d3aac08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rooms/Rooms.vue
// module id = 400
// module chunks = 1